var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6265 0L12.0553 1.64636L0 17.8292L27.6265 50L55.2529 17.8292L43.1978 1.64636L27.6265 0Z",
    fill: "#FDB300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.8301L27.6265 50.0007L11.19 17.8301H0Z",
    fill: "#EB6C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0627 17.8301L27.6265 50.0007L55.2527 17.8301H44.0627Z",
    fill: "#EB6C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1899 17.8301L27.6264 50.0007L44.0628 17.8301H11.1899Z",
    fill: "#FDAD00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0552 1.64636L11.1899 17.8292L27.6264 0L12.0552 1.64636Z",
    fill: "#FDD231"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0627 17.8292L43.1976 1.64615L27.6265 0L44.0627 17.8292Z",
    fill: "#FDD231"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0631 17.8295H55.2529L43.1979 1.64648L44.0631 17.8295Z",
    fill: "#FDAD00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.8295H11.19L12.0553 1.64648L0 17.8295Z",
    fill: "#FDAD00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6264 0L11.1899 17.8292H44.0628L27.6264 0Z",
    fill: "#FEEEB7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.ae651a79afbcf0ca510693fc7610ab03.svg";
export { ForwardRef as ReactComponent };